<template>
  <div>
    <button
      class="text-body-2 link-decoration-none primary--text ml-10"
      @click="isOpened = true"
    >
      {{ t('Смотреть фото', l10nOptions) }}
    </button>

    <CoreDialog
      v-model="isOpened"
      :title="t('Фото', l10nOptions)"
      divider
      :size="isMobile ? 'fullscreen' : 'xl'"
    >
      <template #prependBtn="{ btnProps }">
        <v-btn
          v-bind="btnProps"
          @click="isOpened = false"
        >
          <span class="ui-icon-close-not-a-circle" />
        </v-btn>
      </template>
      <template #default>
        <div
          class="b-swiper lpu-access-gallery"
          :class="isMobile ? 'w-100 py-10' : 'mx-n4'"
        >
          <div class="b-swiper__track">
            <div
              v-for="(image, i) in images"
              :key="i"
              class="b-swiper__slide w-100"
            >
              <v-img
                contain
                :aspect-ratio="isMobile ? 1 : 3 / 2"
                :src="image"
              />
            </div>
          </div>
        </div>
      </template>
      <template
        v-if="!isMobile"
        #actions
      >
        <v-btn
          text
          depressed
          color="primary"
          @click="isOpened = false"
        >
          {{ t('Закрыть', l10nOptions) }}
        </v-btn>
      </template>
    </CoreDialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import I18NextVue from 'i18next'
import SwiperModule from 'www/modules/SwiperModule'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'

defineProps<{
  images: string[]
}>()

const isOpened = ref(false)
const isMobile = ref(window.MOBILE_VERSION)

const { t, language } = I18NextVue
const l10nOptions = { ns: language }

const unwatch = watch(() => isOpened.value, () => {
  if (!isOpened.value) {
    return
  }

  new SwiperModule({
    module: {
      modifier: 'lpu-access-gallery',
    },
    swiper: {
      slidesPerView: 1,
      pagination: true,
      navigation: true,
    },
  })

  unwatch()
})
</script>

<style scoped>
.lpu-access-gallery {
  :deep(.lpu-access-gallery__navigation) {
    padding: 0 6px;
  }

  :deep(.lpu-access-gallery__pagination) {
    margin-top: 24px;
  }
}
</style>
